import { render, staticRenderFns } from "./helpResources.vue?vue&type=template&id=7ccf49ad&"
import script from "./helpResources.vue?vue&type=script&lang=js&"
export * from "./helpResources.vue?vue&type=script&lang=js&"
import style0 from "./helpResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports